<template>
  <div>
    <custom-form-item :label="title" :append-span="2">
      <template #append>
        <el-button @click="add" :disabled="item.length >= max"
          ><i class="fas fa-plus"></i
        ></el-button>
      </template>
    </custom-form-item>

    <custom-form-item
      v-for="(i, index) in item"
      :key="index"
      :label="`${index + 1}`"
      label-width="10px"
      :gutter="10"
      :append-span="2"
    >
        <slot :index="index"></slot>
      <template #append>
        <el-button
          @click="remove(index)"
          :disabled="item.length <= min"
          v-show="index >= deleteIndex"
          ><i class="fas fa-trash-alt"></i></el-button
      ></template>
    </custom-form-item>
  </div>
</template>

<script>
import CustomFormItem from "@/components/base/forms/customFormItem.vue";
export default {
  props: {
    value: Array,
    title: String,
    groupItem: Object,
    max: Number,
    min: Number,
    deleteIndex: { type: Number, default: 0 },
  },
  data() {
    return {
      item: this.value,
    };
  },
  components: {
    CustomFormItem,
  },
  watch: {
    value(newVal) {
      this.item = newVal;
    },
    item(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {
    add() {
      this.item.push(_.cloneDeep(this.groupItem || ''));
    },
    remove(index) {
      this.item.splice(index, 1);
    },
  },
};
</script>

<style></style>
